<template>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    aria-label="main navigation"
    :style="{ backgroundColor: secondaryColor }"
  >
    <div class="powered-by-container">
      <div class="powered-by-text">
        <span>{{ $t("powerByText") }}</span>
      </div>
      <a
        class="powered-by-img-container"
        :href="
          isUploading
            ? null
            : powerUrl !== ''
            ? powerUrl
            : 'https://www.shaga3app.com/en/'
        "
        target="_blank"
      >
        <img
          class="powered-by-img"
          v-lazysizes
          :src="powerLogo !== '' ? powerLogo : poweredBy"
          alt="Powered"
        />
      </a>
    </div>
    <div>
      <div class="main-header-container">
        <div class="logo" :style="lang === 'ar' ? { textAlign: 'end' } : {}">
          <a :href="isUploading ? null : companyUrl" target="_blank">
            <img
              v-lazysizes
              :src="logo"
              style="margin-top: 8px;max-height: 50px;"
            />
          </a>
        </div>
        <div class="counter">
          <div
            v-if="
              countdown &&
                !isOpen &&
                !checkIsFinished &&
                !checkWinner &&
                !comeptitionIsFinished
            "
          >
            <vac
              :end-time="countdown"
              :startTime="startTime"
              ref="counter"
              :speed="1000"
            >
              <div slot="process" slot-scope="{ timeObj }">
                <div style="font-size: 0.6rem">
                  <span style="color:#fff;margin: 0 5px">{{
                    $t("counterTitle")
                  }}</span>
                </div>
                <span class="counter-container">
                  <span>
                    <span class="counter-number">{{
                      lang === "ar" ? arabicize(timeObj.d) : timeObj.d
                    }}</span>
                    <span class="counter-text">{{
                      $t("counterDay")
                    }}</span></span
                  >
                  <span>
                    <span class="counter-number">{{
                      lang === "ar" ? arabicize(timeObj.h) : timeObj.h
                    }}</span>
                    <span class="counter-text">{{
                      $t("counterHours")
                    }}</span></span
                  >
                  <span>
                    <span class="counter-number">{{
                      lang === "ar" ? arabicize(timeObj.m) : timeObj.m
                    }}</span>
                    <span class="counter-text">{{
                      $t("counterMinutes")
                    }}</span></span
                  >
                  <span>
                    <span class="counter-number">{{
                      lang === "ar" ? arabicize(timeObj.s) : timeObj.s
                    }}</span>
                    <span class="counter-text">{{
                      $t("counterSeconds")
                    }}</span></span
                  >
                </span>
                {{
                  timeObj.d == 0 &&
                  timeObj.h == 0 &&
                  timeObj.m == 0 &&
                  timeObj.s == 0
                    ? finish()
                    : ""
                }}
              </div>
            </vac>
          </div>
          <!--Competition Ended -->
          <div style="margin: 20px 0" v-if="comeptitionIsFinished">
            <span style="color:#fff;font-weight: bold">
              {{ $t("counterFinished") }}
            </span>
          </div>
          <!--calculate winner -->
          <div style="margin: 10px 0" v-if="checkIsFinished">
            <span style="color:#fff;font-weight: bold">
              {{ $t("counterProcessing") }}
            </span>
          </div>
          <div style="margin: 20px 0" v-if="checkWinner">
            <div style="text-align: center">
              <span style="color:#fff;" v-html="$t('counterWinner')"></span>
            </div>
            <div style="text-align: center">
              <span style="color:#fff;font-weight: bold">{{ winnerName }}</span>
            </div>
          </div>
          <div id="container" v-if="!checkWinner"></div>
        </div>
        <div class="search-container">
          <a
            role="button"
            @click="isUploading ? '' : $router.push('/search')"
            v-bind:class="{ 'is-active': isOpen }"
            v-if="!isOpen"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              :style="lang === 'ar' ? { transform: 'scaleX(-1)' } : {}"
            >
              <g
                id="Icons/search"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M11,2.25 C15.8324916,2.25 19.75,6.16750844 19.75,11 C19.75,13.0584575 19.0362432,15.0065673 17.758098,16.5583591 L17.693,16.634 L22.0303301,20.9696699 C22.2670115,21.2063513 22.3124352,21.561865 22.1666012,21.8441588 L22.1029482,21.9462117 L22.0303301,22.0303301 C21.7986594,22.2620008 21.4486763,22.312955 21.1520638,22.1613342 L21.0554051,22.1032612 L20.9696475,22.0303076 L16.634,17.693 L16.5583591,17.758098 C15.1789886,18.894227 13.4864779,19.5844196 11.6816733,19.7237695 L11.3420055,19.7434168 L11,19.75 C6.16750844,19.75 2.25,15.8324916 2.25,11 C2.25,6.16750844 6.16750844,2.25 11,2.25 Z M11,3.75 C6.99593556,3.75 3.75,6.99593556 3.75,11 C3.75,15.0040644 6.99593556,18.25 11,18.25 C15.0040644,18.25 18.25,15.0040644 18.25,11 C18.25,6.99593556 15.0040644,3.75 11,3.75 Z"
                  id="Combined-Shape"
                  fill="#fff"
                ></path>
              </g>
            </svg>
          </a>
        </div>
        <div class="menu-container" style="text-align: center">
          <a role="button" @click="isUploading ? '' : (isOpen = !isOpen)">
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              v-if="!isOpen"
              :style="lang === 'ar' ? { transform: 'scaleX(-1)' } : {}"
            >
              <g
                id="Icons/menu"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M14,15.25 C14.4142136,15.25 14.75,15.5857864 14.75,16 C14.75,16.3796958 14.4678461,16.693491 14.1017706,16.7431534 L14,16.75 L3,16.75 C2.58578644,16.75 2.25,16.4142136 2.25,16 C2.25,15.6203042 2.53215388,15.306509 2.89822944,15.2568466 L3,15.25 L14,15.25 Z M21,8.25 C21.4142136,8.25 21.75,8.58578644 21.75,9 C21.75,9.37969577 21.4678461,9.69349096 21.1017706,9.74315338 L21,9.75 L3,9.75 C2.58578644,9.75 2.25,9.41421356 2.25,9 C2.25,8.62030423 2.53215388,8.30650904 2.89822944,8.25684662 L3,8.25 L21,8.25 Z"
                  id="Combined-Shape"
                  fill="#fff"
                  transform="translate(12.000000, 12.500000) scale(-1, 1) translate(-12.000000, -12.500000) "
                ></path>
              </g>
            </svg>
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              v-else
            >
              <g
                id="Icons/close"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M11.8766417,2.00829893 C11.4329138,2.0684958 11.0909091,2.44885362 11.0909091,2.90909091 L11.089697,11.0909091 L2.90909091,11.0909091 L2.7730982,11.1018835 C2.3164165,11.1835228 2,11.558745 2,12 L2.00829893,12.1233583 C2.0684958,12.5670862 2.44885362,12.9090909 2.90909091,12.9090909 L11.089697,12.9090909 L11.0909091,21.0909091 L11.1018835,21.2269018 C11.1835228,21.6835835 11.558745,22 12,22 L12.1233583,21.9917011 C12.5670862,21.9315042 12.9090909,21.5511464 12.9090909,21.0909091 L12.9078788,12.9090909 L21.0909091,12.9090909 L21.2269018,12.8981165 C21.6835835,12.8164772 22,12.441255 22,12 L21.9917011,11.8766417 C21.9315042,11.4329138 21.5511464,11.0909091 21.0909091,11.0909091 L12.9078788,11.0909091 L12.9090909,2.90909091 L12.8981165,2.7730982 C12.8164772,2.3164165 12.441255,2 12,2 L11.8766417,2.00829893 Z"
                  id="Combined-Shape"
                  fill="#fff"
                  transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
                ></path>
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div
        class="menu"
        v-bind:class="{ active: isOpen }"
        :style="{ backgroundColor: secondaryColor }"
      >
        <div style="text-align: start">
          <router-link
            to="/"
            class="item tab"
            :style="{ color: '#fff', textTransform: 'capitalize' }"
            :event="isUploading ? '' : 'click'"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Icons/award"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="award"
                  transform="translate(5.000000, 1.000000)"
                  fill="#fff"
                >
                  <path
                    d="M7,-0.75 C11.2802068,-0.75 14.75,2.71979319 14.75,7 C14.75,9.56006993 13.5086972,11.8302181 11.5951299,13.241406 L12.7434848,21.9013578 C12.8214971,22.4893513 12.2251566,22.9165409 11.7049806,22.6899865 L11.6141282,22.6431197 L7,19.874 L2.38587182,22.6431197 C1.87721289,22.9483151 1.24824489,22.5706628 1.24959295,22.0032522 L1.25652928,21.9012514 L2.40586248,13.2421377 C0.491732,11.8310029 -0.75,9.56051247 -0.75,7 C-0.75,2.71979319 2.71979319,-0.75 7,-0.75 Z M10.1911524,14.0646015 C9.21797036,14.5048903 8.13760939,14.75 7,14.75 C5.86277887,14.75 4.78276709,14.5050576 3.80984403,14.0650522 L2.948,20.556 L6.61412818,18.3568803 C6.81770972,18.2347314 7.0647912,18.2172815 7.28080129,18.3045308 L7.38587182,18.3568803 L11.051,20.556 Z M7,0.75 C3.54822031,0.75 0.75,3.54822031 0.75,7 C0.75,10.4517797 3.54822031,13.25 7,13.25 C8.21975457,13.25 9.35789906,12.9005857 10.3197995,12.296391 C10.3555222,12.2666853 10.3948955,12.2405137 10.4367953,12.2181455 C12.1322183,11.1021833 13.25,9.18162761 13.25,7 C13.25,3.54822031 10.4517797,0.75 7,0.75 Z"
                    id="Combined-Shape"
                  ></path>
                </g>
              </g>
            </svg>
            {{ $t("mainMenuHome") }}
          </router-link>
          <router-link
            to="/points"
            class="item tab"
            :style="{ color: '#fff' }"
            :event="isUploading ? '' : 'click'"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Icons/points"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M16.5832653,2.02462585 C20.1189569,2.02462585 22.9954649,4.90113379 22.9954649,8.4368254 C22.9954649,9.85287982 22.5671202,11.3321995 21.7221315,12.8395465 C22.2982766,13.7473923 22.632381,14.8232653 22.632381,15.9757823 C22.632381,19.2124263 19.9991837,21.8456236 16.7625397,21.8456236 C15.59678,21.8456236 14.5093424,21.5039909 13.5950113,20.9156463 C13.1918821,21.1944218 12.7804082,21.4695692 12.3669388,21.7367347 L12.3669388,21.7367347 L11.9977324,21.9753288 L11.6285261,21.7367347 C9.7752381,20.5391837 7.10888889,18.6311565 4.93097506,16.3421769 C2.32258503,13.6008163 1,10.9410431 1,8.4368254 C1,4.90113379 3.87650794,2.02462585 7.41219955,2.02462585 C8.43773243,2.02462585 9.41791383,2.25972789 10.3254875,2.72344671 C10.9433107,3.03909297 11.5107937,3.45836735 11.9977324,3.95591837 C12.4847166,3.45836735 13.0521995,3.03904762 13.6699773,2.72344671 C14.5775057,2.25972789 15.5577324,2.02462585 16.5832653,2.02462585 Z M16.7625397,11.4665306 C14.2761451,11.4665306 12.253288,13.4893878 12.253288,15.9758277 C12.253288,18.4622676 14.2760998,20.4851247 16.7625397,20.4851247 C19.2489796,20.4851247 21.2718367,18.4622676 21.2718367,15.9758277 C21.2718367,13.4893878 19.2489342,11.4665306 16.7625397,11.4665306 Z M16.5833107,3.38517007 C14.9796372,3.38517007 13.5064853,4.12181406 12.5416327,5.4061678 L12.5416327,5.4061678 L11.9977324,6.13020408 L11.4538322,5.4061678 C10.4889796,4.12181406 9.01587302,3.38517007 7.41219955,3.38517007 C4.62671202,3.38517007 2.36054422,5.65133787 2.36054422,8.4368254 C2.36054422,10.5802268 3.55696145,12.9244444 5.91664399,15.4043537 C7.86303855,17.4500227 10.2338776,19.1890249 11.9977324,20.3529252 C12.1678458,20.2406803 12.3370068,20.1270295 12.5053515,20.0127891 C11.5064853,18.9599093 10.8927891,17.5382766 10.8927891,15.975873 C10.8927891,12.739229 13.525941,10.1060317 16.762585,10.1060317 C18.3175057,10.1060317 19.7329252,10.7140136 20.784263,11.7043991 C21.3490703,10.5702948 21.634966,9.47437642 21.634966,8.4368254 C21.634966,5.65133787 19.3687982,3.38517007 16.5833107,3.38517007 Z M17.4428118,13.1814966 L17.4428118,15.2956009 L19.5569161,15.2956009 L19.5569161,16.6561451 L17.4428118,16.6561451 L17.4428118,18.7702041 L16.0822676,18.7702041 L16.0822676,16.6561451 L13.9681633,16.6561451 L13.9681633,15.2956009 L16.0822676,15.2956009 L16.0822676,13.1814966 L17.4428118,13.1814966 Z"
                  id="Combined-Shape"
                  fill="#fff"
                ></path>
              </g>
            </svg>
            {{ $t("mainMenuPoints") }}
          </router-link>
          <router-link
            to="/terms"
            class="item tab"
            :style="{ color: '#fff', textTransform: 'capitalize' }"
            :event="isUploading ? '' : 'click'"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Icons/statement"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M14.25,2.25 L14.25,2.305 L14.2795867,2.31352228 L14.3385635,2.33923894 L14.3982839,2.37431403 L14.4651464,2.42146125 L14.5474012,2.48674098 L20.5553248,8.50851216 L20.6567815,8.69822705 L20.678,8.745 L20.75,8.74381795 L20.75,20 C20.75,21.3934396 19.7103856,22.5542707 18.3448031,22.7280276 L18.1724592,22.7445516 L18,22.75 L6,22.75 C4.60656041,22.75 3.44572933,21.7103856 3.27197242,20.3448031 L3.2554484,20.1724592 L3.25,20 L3.25,5 C3.25,3.60656041 4.28961439,2.44572933 5.65519691,2.27197242 L5.82754085,2.2554484 L6,2.25 L14.25,2.25 Z M13.25,3.75 L6,3.75 C5.39753972,3.75 4.88886119,4.17823462 4.7748623,4.74414245 L4.75658464,4.86740977 L4.75,5 L4.75,20 C4.75,20.6024603 5.17823462,21.1111388 5.74414245,21.2251377 L5.86740977,21.2434154 L6,21.25 L18,21.25 C18.6024603,21.25 19.1111388,20.8217654 19.2251377,20.2558575 L19.2434154,20.1325902 L19.25,20 L19.25,9.748 L15,9.75 C14.1464034,9.75 13.427507,9.13625472 13.2776066,8.30516767 L13.2571485,8.15632979 L13.25,8 L13.25,3.75 Z M10.5,15.25 C10.9142136,15.25 11.25,15.5857864 11.25,16 C11.25,16.3276319 11.0385547,16.6111373 10.7216058,16.713662 L10.612194,16.7409461 L10.5,16.75 L7.5,16.75 C7.08578644,16.75 6.75,16.4142136 6.75,16 C6.75,15.6723681 6.96144533,15.3888627 7.27839418,15.286338 L7.38780601,15.2590539 L7.5,15.25 L10.5,15.25 Z M13.5,11.25 C13.9142136,11.25 14.25,11.5857864 14.25,12 C14.25,12.3276319 14.0385547,12.6111373 13.7216058,12.713662 L13.612194,12.7409461 L13.5,12.75 L7.5,12.75 C7.08578644,12.75 6.75,12.4142136 6.75,12 C6.75,11.6723681 6.96144533,11.3888627 7.27839418,11.286338 L7.38780601,11.2590539 L7.5,11.25 L13.5,11.25 Z M14.75,4.81 L14.75,8 C14.75,8.0842684 14.7920728,8.16062014 14.8478071,8.20281185 L14.8917254,8.22764059 L14.9324427,8.24294254 L15,8.25 L18.19,8.25 L14.75,4.81 Z"
                  id="Combined-Shape"
                  fill="#fff"
                ></path>
              </g>
            </svg>
            {{ $t("terms") }}
          </router-link>
          <router-link
            to="/faq"
            class="item tab"
            :style="{ color: '#fff', textTransform: 'capitalize' }"
            :event="isUploading ? '' : 'click'"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Icons/support"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="help-circle"
                  transform="translate(1.000000, 1.000000)"
                  fill="#fff"
                >
                  <path
                    d="M10.75,0 C16.6870611,0 21.5,4.81293894 21.5,10.75 C21.5,16.6870611 16.6870611,21.5 10.75,21.5 C4.81293894,21.5 0,16.6870611 0,10.75 C0,4.81293894 4.81293894,0 10.75,0 Z M10.75,1.5 C5.64136606,1.5 1.5,5.64136606 1.5,10.75 C1.5,15.8586339 5.64136606,20 10.75,20 C15.8586339,20 20,15.8586339 20,10.75 C20,5.64136606 15.8586339,1.5 10.75,1.5 Z M10.76,15 C11.1742136,15 11.51,15.3357864 11.51,15.75 C11.51,16.1296958 11.2278461,16.443491 10.8617706,16.4931534 L10.75,16.5 C10.3357864,16.5 10,16.1642136 10,15.75 C10,15.3703042 10.2821539,15.056509 10.6482294,15.0068466 L10.76,15 Z M11.3039696,5.04950748 C13.1062094,5.35863953 14.4227225,6.92255705 14.420016,8.75 C14.420016,9.92854393 13.7107364,10.8742322 12.5860265,11.6240379 C11.9587117,12.0422474 11.3399439,12.3172549 10.9071706,12.4615126 C10.5142131,12.5924983 10.0894731,12.3801281 9.95848745,11.9871706 C9.82750175,11.5942131 10.0398719,11.1694731 10.4328294,11.0384874 L10.5512738,10.9952958 L10.834147,10.8771412 C11.1493651,10.7370444 11.4643032,10.5690776 11.7539769,10.3759621 C12.5042691,9.87576779 12.9200034,9.32145607 12.9200042,8.74888438 C12.9216362,7.65174761 12.1317274,6.71339603 11.0503831,6.52791672 C9.96903855,6.34243739 8.91157849,6.96391598 8.54750083,7.99888265 C8.41004674,8.38962457 7.98185927,8.59495492 7.59111735,8.45750083 C7.20037543,8.32004674 6.99504508,7.89185927 7.13249917,7.50111735 C7.73929526,5.7761729 9.50172869,4.74037526 11.3039696,5.04950748 Z"
                    id="Combined-Shape"
                  ></path>
                </g>
              </g>
            </svg>
            {{ $t("faq") }}
          </router-link>
          <a
            @click="loginHandler"
            class="item tab"
            :style="{ color: '#fff', textTransform: 'capitalize' }"
            v-if="isGuest"
            :event="isUploading ? '' : 'click'"
            >{{ $t("mainMenuLogin") }}</a
          >
          <!-- <router-link to="/lang" class="item tab" :style="{color: '#fff'}" :event="isUploading ? '' : 'click'">{{$t('mainMenuLanguage')}}</router-link> -->
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import PoweredBy from "../../assets/mainImage/Powered-by.png";
export default {
  props: ["countdown"],
  data() {
    return {
      winnerName: "",
      progressCounter: 0,
      connection: null,
      poweredBy: PoweredBy,
      isOpen: false,
      isFinished: false,
      startTime: Math.floor(new Date().getTime())
    };
  },
  methods: {
    getNewWinner() {
      this.$confetti.start();
      this.isFinished = false;
      setTimeout(() => {
        this.$store.dispatch("checkNewCountDown");
        this.winnerName = "";
        this.$confetti.stop();
      }, 10000);
    },
    loginHandler() {
      let slug = localStorage.getItem("sl");
      if (slug === "pyramids") {
        const sub = window.location.host.split(".")[0];
        if (sub !== "dev") {
          window.open("https://pyramidsfc.shaga3app.com/", "_self");
        } else {
          window.open("https://dev.pyramidsfc.shaga3app.com/", "_self");
        }
      } else {
        this.$router.push({ name: "login" });
      }
    },
    closeMenu(e) {
      if (this.isOpen && e.toElement.id !== "burgerMenu") {
        this.isOpen = false;
      }
    },
    arabicize(value) {
      const arabicNums = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
      return value.toString().replace(/[0-9]/g, function(w) {
        return arabicNums[+w];
      });
    },
    finish() {
      this.isFinished = true;
      if (this.connection.readyState !== 1) {
        if (sub === "frontend") {
          this.connection = new WebSocket("wss://backend.shaga3app.com");
        } else {
          this.connection = new WebSocket("wss://dev.backend.shaga3app.com");
        }
      }
      document.getElementById("container").innerHTML = null;
      var ProgressBar = require("progressbar.js");
      var bar = new ProgressBar.Line(document.getElementById("container"), {
        strokeWidth: 4,
        easing: "easeInOut",
        duration: 60000,
        color: "#FFEA82",
        trailColor: "#eee",
        trailWidth: 1,
        svgStyle: { width: "100%", height: "100%" },
        from: { color: "#FFEA82" },
        to: { color: "#ED6A5A" },
        step: (state, bar) => {
          bar.path.setAttribute("stroke", state.color);
        }
      });
      bar.animate(1);
      // this.$store.dispatch("fetchCountdown");
    }
  },
  computed: {
    checkWinner() {
      if (this.winnerName.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    checkIsFinished() {
      if (this.winnerName.length === 0) {
        if (this.$store.getters.competitionLocked) {
          this.isFinished = true;
          return true;
        }
        return this.isFinished;
      } else {
        return false;
      }
    },
    companyUrl() {
      return this.$store.getters.companyUrl;
    },
    powerUrl() {
      return this.$store.getters.powerUrl;
    },
    isGuest() {
      return this.$store.getters.isGuest;
    },
    logo() {
      return this.$store.getters.headerLogo;
    },
    powerLogo() {
      return this.$store.getters.powerLogo;
    },
    secondaryColor() {
      return this.$store.getters.secondaryColor;
    },
    primaryColor() {
      return this.$store.getters.primaryColor;
    },
    lang() {
      return this.$store.getters.lang;
    },
    margin() {
      if (this.$route.name === "home" || this.$route.name === "fans") {
        return {
          "--margin": "63px 0 0 ",
          "--color": this.primaryColor
        };
      } else {
        return {
          "--margin": "13px 0 0",
          "--color": this.primaryColor
        };
      }
    },
    isUploading() {
      return this.$store.getters.isUploading;
    },
    currentComp() {
      return this.$store.getters.currentComp;
    },
    comeptitionIsFinished() {
      return this.$store.getters.selectedCompetitionIsFinished;
    }
  },
  updated() {
    if (this.countdown > 0) {
      const sub = window.location.host.split(".")[0];
      if (this.connection === null) {
        if (sub === "frontend") {
          this.connection = new WebSocket("wss://backend.shaga3app.com");
        } else {
          this.connection = new WebSocket("wss://dev.backend.shaga3app.com");
        }
      } else if (this.connection.readyState !== 1) {
        if (sub === "frontend") {
          this.connection = new WebSocket("wss://backend.shaga3app.com");
        } else {
          this.connection = new WebSocket("wss://dev.backend.shaga3app.com");
        }
      }
      this.connection.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          const competitionId = localStorage.getItem("competitionId");
          if (data.event) {
            if (data.event === "competition-success") {
              if (competitionId === data.identifier) {
                if (data.winnerName.length !== 0) {
                  this.winnerName = data.winnerName;
                } else {
                  this.winnerName = "Winner";
                }
                this.connection.close();
                this.getNewWinner();
              }
            }
          }
        } catch (err) {}
      };
      this.connection.onerror = event => {
        console.log("error");
        this.connection.close();
      };
      this.connection.onclose = event => {
        this.connection.close();
      };
    }
  },
  beforeUnmount() {
    if (this.connection) {
      this.isFinished = false;
      this.connection.close();
    }
  }
};
</script>

<style scoped>
nav {
  padding: 0;
  display: block;
  width: 100%;
  height: 105px;
  color: #eee;
  z-index: 60 !important;
}
.main-header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 10px;
}
.logo {
  width: 25%;
  margin: auto 0;
  padding: 0 5px;
  text-align: start;
}
.menu {
  display: none;
  background-color: #fff;
  width: 100%;
  position: absolute;
  z-index: 2000;
  top: 100px;
  padding: 25px;
}
.menu.active {
  display: block !important;
}
a.item {
  cursor: pointer;
}
.item {
  display: block;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  color: #4a4a4a;
  line-height: 1.5;
  padding: 0.5rem 0.75rem;
  position: relative;
}
.item.tab {
  border-bottom: 1px solid transparent;
  min-height: 3.25rem;
  padding-bottom: calc(0.5rem - 1px);
}
.powered-by-container {
  background-color: rgba(17, 17, 17, 0.15);
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
}
.powered-by-text {
  color: #ffffff;
  font-family: Cairo;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}
.powered-by-img-container {
  width: 50px;
  height: 22px;
  margin: 0 10px;
}
.powered-by-img {
  width: 100%;
  height: 100%;
}
.counter {
  text-align: center;
  font-size: 15px;
  width: 50%;
  min-height: 70px;
}
.counter p {
  font-weight: 700;
}
.counter-container {
  color: #fff;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 90%;
  margin: 0 auto;
}
.counter-number {
  display: block;
  background: rgba(255, 255, 255, 0.1);
  width: 26px;
  border-radius: 3px;
  font-family: Cairo;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 29px;
  text-align: center;
}
.counter-text {
  color: #ffffff;
  font-family: Cairo;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}
.search-container {
  width: 7%;
  margin: auto;
}
.menu-container {
  width: 13%;
}
#container {
  margin: 5px auto;
  width: 100%;
  height: 5px;
}
</style>
